<div class="container" style="width: 100%" (click)="onClick()">
   <button kendoButton look="flat" style="width: 100%" (click)="onClick()">
      <fa-icon [fixedWidth]="true" class="sam-center attachment-icon" [icon]="fileIcon"></fa-icon>
      <div fxFlex="1 1 auto" class="sam-hide-overflow">
         <div>
            <samweb-text-with-overflow-tooltip [value]="attachment.name" class="attachment-name">
            </samweb-text-with-overflow-tooltip>
         </div>
         <div>
            <samweb-text-with-overflow-tooltip
               [value]="this.attachment.fileSize | formatBytes | async"
               class="attachment-size"
            >
            </samweb-text-with-overflow-tooltip>
         </div>
      </div>
   </button>
   <fa-icon [fixedWidth]="true" class="sam-center overlay" [icon]="overlayIcon"></fa-icon>
</div>
